import ImagePreview from './imagePreview'

export default ImagePreview
